/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'base-ssubject': {
    width: 15.342,
    height: 16,
    viewBox: '0 0 15.342 16',
    data: '<path pid="0" d="M2.1 13.144a.888.888 0 10-.017 1.764H14.8A.546.546 0 0114.809 16H2.1A2.036 2.036 0 010 14.026a1.9 1.9 0 01.484-1.262A1.465 1.465 0 010 11.675V1.47A1.471 1.471 0 011.471 0h2.186v5.174a.458.458 0 00.752.325l.009-.008L5.611 4.44 6.8 5.492l.009.008a.458.458 0 00.752-.337V0h5.759a1.47 1.47 0 011.48 1.47v10.2a1.47 1.47 0 01-1.471 1.47zM7.062 0v5.039L6.035 4.06l-.013-.012-.007-.006a.6.6 0 00-.82.012l-.007.007-1.027.979V0z" _fill="#212121"/>'
  }
})
